import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import Product from "emun.shopping/product.model";
import labels from "emun.order/_labels";
import ProductListPicker from "emun.products/lists/product-list-picker";
import resolve from "ioc/resolve";
import modals from "webmodals/modals";
import actionList from "webmodals/action-list";
import ServiceBus from "servicestack/service-bus";
import cartConfig from "emun.cart/cart.config";
import cartItemInputConfig from "emun.cart/cart-item-input.config";
import cartItemShipDatePrompt from "emun.cart/cart-item-ship-date";
import cartItemCancelDatePrompt from "emun.cart/cart-item-cancel-date";
import orderConfig from "emun.order/order.config";
import OrderDetailsPrompt from "emun.order/modify-order/modify-order-prompt";


const $localStorage = resolve("$localStorage");
const $rootScope = resolve("$rootScope");

const productSorter = (scan) => (a, b) => {
	const aI = a.id.indexOf(scan);
	const bI = b.id.indexOf(scan);
	if (aI === -1 && bI >= 0) return 1;orde
	if (bI === -1 && aI >= 0) return -1;
	if (aI >= 0 && bI >= 0 && aI > bI) return 1;
	if (aI >= 0 && bI >= 0 && bI > aI) return -1;
	if (bI === aI && aI >= 0) {
		const skuComp = skuLengthSorter(a, b);
		if (skuComp !== 0) return skuComp;
		return availableQtySorter(a, b);
	}
	return availableQtySorter(a, b);
};
const skuLengthSorter = (a, b) => {
	if (a.id.length > b.id.length) return 1;
	if (b.id.length > a.id.length) return -1;
	return 0;
};
const availableQtySorter = (a, b) => {
	if (a.availableQty > b.availableQty) return -1;
	if (b.availableQty > a.availableQty) return 1;
	return 0;
};

export default class ModifyOrderController {
	constructor(notify) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.labels = labels;
		$ctrl.notify = notify;
		$ctrl.bus = new ServiceBus();
	}

	$onInit() {
		const $ctrl = this;
		$ctrl.additions = [];
		$ctrl.labels = {
			id: "ID",
			shortDescription: "Desc",
			price: "Price",
			extPrice: "Ext. Price",
			cubicVolume: false,
			caseQty: "Case Qty",
			availableQty: $ctrl.$labels.availableQty || "Avail",
			addWithAdditionalInfo: "Add with additional info",
			add: "Add",
			searchResults: "Search Results",
			shipOn: $ctrl.$labels.shipOn,
		};
		$ctrl.config = cartConfig;
		$ctrl.orderConfig = orderConfig;
		$ctrl.$cart.$$load.then(function () {
			$ctrl.$cart.origPO = $ctrl.$cart.purchaseOrder;
			$ctrl.$cart.origShipDate = moment.utc($ctrl.$cart.shipOn).format("l");
			$ctrl.$cart.origCancelDate = moment.utc($ctrl.$cart.cancelOn).format("l");
		});
		$ctrl.$cart.items.map((l) => (l.selected = false));
		$ctrl.bus.send('QueryReasonCodes.json').then(res => $ctrl.reasonCodes = res.data.results);
		$ctrl.prodQuery = new AutoQuery({
			url: "QueryProducts.json?V=Scan",
			autoLoad: false,
			orderBy: cartItemInputConfig.orderBy || "Id",
			criteria: {
				//  IsRestricted: 0
			},
			pageSize: 12,
			beforeLoading({ request }) {
				request.cartId = $ctrl.$cart.cartId;
			},
			scrub: (res) =>
				(res.data.results = Product.map(
					cartItemInputConfig.disableProductSorter ? res.data.results : res.data.results.sort(productSorter($ctrl.prodQuery.criteria.scan))
				)),
			onLoaded: (args) => $ctrl.productsLoaded(args),
		});
	}

	getProduct(skuOrUpc) {
		const $ctrl = this;
		//console.info("getProduct", skuOrUpc);
		$ctrl.shipOn = undefined;
		if (skuOrUpc && skuOrUpc != "") {
			$ctrl.prodQuery.bus.cancelAll();
			$ctrl.prodQuery.bus
				.read("QueryProducts.json?cart-item-input=getProductyBySkuOrUpc", {
					cartId: $ctrl.$cart.cartId,
					skuOrUpc,
				})
				.then((res) => {
					if (res.data.results.length > 0) {
						$ctrl.setProduct(new Product(res.data.results[0]));
					} else {
						//console.info("$ctrl.$cart", $ctrl.$cart);
						//console.info("$ctrl.prodQuery.criteria.scan.toUpperCase()", $ctrl.prodQuery.criteria.scan.toUpperCase());
						if (
							$ctrl.$session.isAgency() &&
							$ctrl.$cart.vendor &&
							($ctrl.$cart.vendor.allowManualItemEntry ||
								($ctrl.$cart.sourceId.toUpperCase() == "DIRECT" &&
									$ctrl.prodQuery.criteria.scan.toUpperCase() == "SUMMARY"))
						) {
							if (cartConfig.playErrorSound) {
								$ctrl.errorSound.play();
							}
							const invalidItemActions = {
								"Add New Item": {
									icon: "cart-plus",
									body: `Enter ${$ctrl.prodQuery.criteria.scan} as a new item`,
									handler: () =>
										$ctrl.openNewItem($ctrl.prodQuery.criteria.scan),
								},
								Cancel: {
									icon: "close",
									body: "Cancel",
									handler: function () {
										return;
									},
								},
							};
							return actionList({
								title: `${$ctrl.prodQuery.criteria.scan} is not a valid item`,
								subTitle: `How would you like to proceed?`,
								actions: invalidItemActions,
								size: "md",
							}).then((a) => a.handler());
						}
					}
				});
		}
	}
	setProduct(p) {
		const $ctrl = this;
		//console.info("setProduct", p);
		var isConfigurable = false;
		$ctrl.products = [];
		$ctrl.$selectedIndex = null;
		$ctrl.invalid = false;
		$ctrl.product = p;
		$ctrl.quantity = $ctrl.product.minimumOrderQty || 1;
		$ctrl.product.qtyIncrement = $ctrl.product.purchaseIncrement || 1;
		$ctrl.product.shipDate = $ctrl.$cart.shipOn;
		//$ctrl.product.shipOn = $ctrl.$cart.shipOn;
		$ctrl.prodQuery.criteria.scan = "";
		$ctrl.$cart.bus
			.validate(
				"AddCartItem.json?cart-item-input=validate",
				p.createCartItem(null, null, $ctrl.quantity)
			)
			.then(
				() => {
					if ($ctrl.product.optionGroup || $ctrl.product.meta.MaxNumLines) {
						$ctrl.editItem();
						isConfigurable = true;
					}
					//console.info("p", p);
					$ctrl.$emit("product-found", p);
					//					if ($ctrl.isMobile()) {
					if ($ctrl.autoAdd && !isConfigurable) $ctrl.addProduct();
					else {
						//if ($ctrl.isMobile()) {
						//	document
						//		.getElementById("cart-item-input-search-or-scan-mobile")
						//		.blur();
						//} else {
						document.getElementById("cart-item-input-search-or-scan").blur();
						//}
					}
					//					}
				},
				() => $ctrl.clear()
			)
			.catch(() => $ctrl.clear());
	}

	clear() {
		const $ctrl = this;
		$ctrl.quantity = null;
		$ctrl.product = null;
		$ctrl.$selectedIndex = null;
		$ctrl.prodQuery.criteria.scan = "";
		$ctrl.products = [];
	}

	editItem() {
		const $ctrl = this;
		if ($ctrl.product) {
			console.debug("editItem", { ...$ctrl.product });
			$ctrl.$cart
				.editItem(
					$ctrl.product.createCartItem(
						null,
						null,
						$ctrl.quantity,
						$ctrl.product.asShownValues
					),
					$ctrl.product
				)
				.then(
					(res) => {
						$ctrl.clear();
						$ctrl.$emit("cart-item-added", res);
					},
					(res) => {
						$ctrl.clear();
						$ctrl.$emit("cart-item-added", res);
					}
				);
		}
	}

	loadProducts(watchSelectedIndex) {
		const $ctrl = this;

		//if (watchSelectedIndex && $ctrl.$selectedIndex >= 0)
		//    return console.warn('lp.cancel', $ctrl.$selectedIndex);
		if (
			($ctrl.prodQuery.criteria.scan || "").length >= 2 ||
			$ctrl.productLineScan
		) {
			$ctrl.$selectedIndex = null;
			$ctrl.product = null;
			//console.info("vendorScan", $ctrl.vendorScan, $ctrl.$cart.vendorId, !$ctrl.config.hideVendorScanOption);
			if (
				$ctrl.vendorScan &&
				!$ctrl.config.hideVendorScanOption &&
				$ctrl.$cart.vendorId > 0
			) {
				$ctrl.prodQuery.criteria.vendorId = $ctrl.$cart.vendorId;
			} else {
				$ctrl.prodQuery.criteria.vendorId = undefined;
			}
			if ($ctrl.productLineScan) {
				$ctrl.prodQuery.criteria.productLineId = $ctrl.productLineScan;
			}
			$ctrl.prodQuery.load(true);
		} else {
			$ctrl.products = [];
		}
	}

	productsLoaded(args) {
		const $ctrl = this;
		$ctrl.products = args.results;
		$ctrl.invalid = false;
		$ctrl.product = null;
		$ctrl.$lastScan = $ctrl.prodQuery.criteria.scan;

		if (
			args.results.length === 1 &&
			(args.first.id.toUpperCase() ===
				$ctrl.prodQuery.criteria.scan.toUpperCase() ||
				args.first.upcCode.toUpperCase() ===
				$ctrl.prodQuery.criteria.scan.toUpperCase() ||
				args.first.manufacturerNumber.toUpperCase() ===
				$ctrl.prodQuery.criteria.scan.toUpperCase())
		) {
			$ctrl.setProduct(args.first);
		} else if (args.results.length === 0) {
			$ctrl.invalid = true;
			//if (cartConfig.playErrorSound && $ctrl.isMobile()) {
			//	$ctrl.errorSound.play();
			//	$ctrl.prodQuery.criteria.scan = "";
			//}
		} else {
			$ctrl.$selectedIndex = 0;
		}
	}

	addProduct() {
		const $ctrl = this;
		$ctrl.keystrokes = [];
		//		if ($ctrl.isMobile()) {
		//			document.getElementById("cart-item-input-search-or-scan-mobile").focus();
		//		} else {
		document.getElementById("cart-item-input-search-or-scan").focus();
		//		}
		if (!$ctrl.product) return;
		if ($ctrl.quantity < 1) return;
		if (
			$ctrl.product.qtyIncrement > 0 &&
			$ctrl.$cart.type.toUpperCase() !== "SAMPLE" &&
			$ctrl.$cart.type.toUpperCase() !== "REPLACEMENT" &&
			$ctrl.$cart.type.toUpperCase() !== "DROP SHIP"
		) {
			if ($ctrl.quantity % $ctrl.product.qtyIncrement) {
				$ctrl.bus.validationErrors = {
					Quantity: [
						{
							errorCode: "-1",
							fieldName: "Quantity",
							message:
								"Quantity must be in increments of " +
								$ctrl.product.qtyIncrement,
						},
					],
				};
				$ctrl.quantity = $ctrl.product.qtyIncrement;
				$ctrl.$emit("product-found", $ctrl.product);
				return;
			}
		}
		let totalAdditions = $ctrl.additions.reduce((s, f) => s + f.extended, 0);
		totalAdditions += ($ctrl.quantity * $ctrl.product.price);;
		if (totalAdditions > $ctrl.orderConfig.maxChangeAmount) {
			modals.alert("Total additions cannot exceed $" + $ctrl.orderConfig.maxChangeAmount + ".  New order will need to be started");
			return;
		}
		$ctrl.additions.push({
			productId: $ctrl.product.id,
			qtyPurchased: $ctrl.quantity,
			price: $ctrl.product.price,
			extended: $ctrl.quantity * $ctrl.product.price
		});
		$ctrl.$cart.items.push(Object.assign($ctrl.product.createCartItem(null, null, $ctrl.quantity), {
			cartId: $ctrl.$cart.id,
			productId: $ctrl.product.id,
			qtyPurchased: $ctrl.quantity,
			price: $ctrl.product.price,
			description: $ctrl.product.shortDescription,
			canModify: false
		}));
		$ctrl.clear();
	}

	submitChanges() {
		const $ctrl = this;
		var cartId = $ctrl.$cart.id;
		let request = {
			cartId: $ctrl.$cart.id,
			changes: []
		};
		var canSubmit = true;
		$ctrl.$cart.items.forEach(item => {
			if (item.qtyPurchased !== item.origQty) {
				if (item.qtyPurchased < item.origQty && !item.reasonCode) {
					canSubmit = false;
				}
				request.changes.push({
					CartId: $ctrl.$cart.id,
					Position: item.position,
					ProductId: item.productId,
					QuantityChange: item.qtyPurchased - item.origQty,
					OldValue: item.origQty,
					NewValue: item.qtyPurchased,
					RequestType: "QUANTITY CHANGE",
					Reason: item.reasonCode
				});
			}
			if (moment.utc(item.shipOn).format("l") !== moment.utc(item.origShipDate).format("l")) {
				request.changes.push({
					CartId: $ctrl.$cart.id,
					Position: item.position,
					ProductId: item.productId,
					OldValue: moment.utc(item.origShipDate).format("l"),
					NewValue: moment.utc(item.$shipOn).format("l"),
					RequestType: "SHIPDATE CHANGE",
					Reason: item.reasonCode
				});
			}
			if (moment.utc(item.cancelOn).format("l") !== moment.utc(item.origCancelDate).format("l")) {
				request.changes.push({
					CartId: $ctrl.$cart.id,
					Position: item.position,
					ProductId: item.productId,
					OldValue: moment.utc(item.origCancelDate).format("l"),
					NewValue: moment.utc(item.$cancelOn).format("l"),
					RequestType: "CANCELDATE CHANGE",
					Reason: item.reasonCode
				});
			}
		});
		if ($ctrl.$cart.origPO !== $ctrl.$cart.purchaseOrder) {
			request.changes.push({
				CartId: $ctrl.$cart.id,
				Position: 0,
				ProductId: "",
				QuantityChange: 0,
				OldValue: $ctrl.$cart.origPO,
				NewValue: $ctrl.$cart.purchaseOrder,
				RequestType: "PO CHANGE",
				Reason: ""
			});
		}
		if (moment.utc($ctrl.$cart.origShipDate).format("l") !== moment.utc($ctrl.$cart.shipOn).format("l")) {
			request.changes.push({
				CartId: $ctrl.$cart.id,
				Position: 0,
				ProductId: "",
				QuantityChange: 0,
				OldValue: moment.utc($ctrl.$cart.origShipDate).format("l"),
				NewValue: moment.utc($ctrl.$cart.shipOn).format("l"),
				RequestType: "HEADER SHIPDATE CHANGE",
				Reason: ""
			});
		}
		if (moment.utc($ctrl.$cart.origCancelDate).format("l") !== moment.utc($ctrl.$cart.cancelOn).format("l")) {
			request.changes.push({
				CartId: $ctrl.$cart.id,
				Position: 0,
				ProductId: "",
				QuantityChange: 0,
				OldValue: moment.utc($ctrl.$cart.origCancelDate).format("l"),
				NewValue: moment.utc($ctrl.$cart.cancelOn).format("l"),
				RequestType: "HEADER CANCELDATE CHANGE",
				Reason: ""
			});
		}
		if ($ctrl.$cart.cancelled) {
			request.changes.push({
				CartId: $ctrl.$cart.id,
				Position: 0,
				ProductId: "",
				QuantityChange: 0,
				RequestType: "ORDER CANCELLED",
				Reason: $ctrl.$cart.cancelReasonCode
			});
		}
		$ctrl.additions.forEach(item => {
			request.changes.push({
				CartId: $ctrl.$cart.id,
				Position: 0,
				ProductId: item.productId,
				QuantityChange: item.qtyPurchased,
				OldValue: 0,
				NewValue: item.qtyPurchased,
				RequestType: "ADD ITEM",
				Reason: ""
			});
		});
		console.debug("BL*** canSubmit", canSubmit);
		if (canSubmit) {
			$ctrl.$dismiss();
			let url = `SubmitChangeRequests.json`;
			let busy = modals.busy(
				"Submitting change requests...",
				`Thank you for your patience as your change requests are submitted.`
			);
			$ctrl.bus
			.send(url, request)
			.then((response) => {
				$ctrl.$cart.load();
			})
			.catch((response) => {
			})
			.finally(busy.close);
		} else {
			return modals.alert("Reason code required when removing items");
		}
	}

	save() {
		const $ctrl = this;
	}
	removeItem(item) {
		let $ctrl = this;
		item.qtyPurchased = 0;
	}
	changeQuantity(item, cartId) {
		let $ctrl = this;
		const cartType = ($ctrl.$cart.type || "").toUpperCase();
		if (item.qtyPurchased === 0) {
			return !item.create && removeItem(item, cartId);
		}
		if (
			item.qtyPurchased < item.minimumOrderQty &&
			cartType !== "SAMPLE" &&
			cartType !== "REPLACEMENT" &&
			cartType !== "DROP SHIP"
		) {
			item.qtyPurchased = item.minimumOrderQty;
			return modals.alert(
				"This item, " +
				item.productId +
				", has reached it's minimum quantity (" +
				item.minimumOrderQty +
				")."
			);
		}
		if (
			item.product.purchaseIncrement > 0 &&
			item.product.enforceMinimum &&
			cartType !== "SAMPLE" &&
			cartType !== "REPLACEMENT" &&
			cartType !== "DROP SHIP"
		) {
			if (item.qtyPurchased % item.product.purchaseIncrement) {
				item.qtyPurchased = item.product.purchaseIncrement;
				const tm = () => {
					// $rootScope.$emit('minimumOrderQty:' + item.productId, { cart, item });
					$rootScope.$emit("minimumOrderQtyC:" + item.productId, {
						cart,
						item,
					});
				};
				return modals
					.alert(
						"Quantity must be in increments of " +
						item.product.purchaseIncrement
					)
					.result.then(() => {
						tm();
						$timeout(tm, 188);
					});
			}
		}
		if (item.create) {
			return;
		}
		let request = {
			id: cartId || $ctrl.$cart.id,
			cartId: cartId || $ctrl.$cart.id,
			productId: item.productId,
			quantity: item.qtyPurchased,
			position: item.position,
		};
		if (item.product && item.product.pricing) {
			Object.keys(item.product.pricing).forEach((key) => {
				if (item.qtyPurchased >= key) {
					item.price = item.product.pricing[key];
					item.pricePaid = item.product.pricing[key];
				}
			});
		}

		item.extendedTotal = item.qtyPurchased * item.price;
		item.subTotal = item.extendedTotal;
	}

	decrementItem(item, cartId) {
		let $ctrl = this;
		item.qtyPurchased = Math.max(
			0,
			item.qtyPurchased - (item.product.purchaseIncrement || 1)
		);
		$ctrl.changeQuantity(item, cartId)
	}

	incrementItem(item, cartId) {
		let $ctrl = this;
		item.qtyPurchased += item.product.purchaseIncrement || 1;

		$ctrl.changeQuantity(item, cartId)
	}
	isModified(item) {
		let $ctrl = this;
		if (item.origQty !== item.qtyPurchased || moment.utc(item.origShipDate).format("l") !== moment.utc(item.shipOn).format("l") || moment.utc(item.origCancelDate).format("l") !== moment.utc(item.cancelOn).format("l")) return true;
		else return false;
	}

	cartItemShipDate(cartItem, cartId) {
		return cartItemShipDatePrompt({
			cartItem,
			product: cartItem.product,
		}).then((cartItem) => {
			cartItem.$shipOn = moment.utc(cartItem.shipOn).format("l");
		});
	}
	cartItemCancelDate(cartItem, cartId) {
		return cartItemCancelDatePrompt({
			cartItem,
			product: cartItem.product,
		}).then((cartItem) => {
			cartItem.$cancelOn = moment.utc(cartItem.cancelOn).format("l");
		});
	}
	edit() {
		const $ctrl = this;
		return (
			OrderDetailsPrompt.open({
				order: $ctrl.$cart,
				mode: $ctrl.mode,
			}).then((res) => {

			})
		);
	}
}
